export default __webpack_public_path__ + "static/media/1965.0c662805.png";